// Ficha dos fornecedores da loja, guardada no servidor (/api/fornecedores). Até a v1.5.812 ela morava no
// navegador (localStorage "fornecedores") e sumia no logout — achados #85 e #103. Usada pela tela
// Fornecedores e pelas sugestões de fornecedor da Nova Compra e da Nova Despesa.
import axios from "axios";

import { scopedKey } from "../utils/tenantScope";
import { getToken } from "../utils/tokenStorage";

const API = "/api";
const LEGADO = "fornecedores"; // a chave antiga do navegador
const cfg = () => ({ headers: { Authorization: `Bearer ${getToken() || ""}` } });

// A lista antiga do navegador no formato do servidor (`cnpj` era o nome antigo do documento).
function lerLegado() {
  try {
    const lista = JSON.parse(localStorage.getItem(LEGADO) || "[]");
    if (!Array.isArray(lista)) return [];
    return lista
      .filter((f) => f && typeof f.nome === "string" && f.nome.trim())
      .map((f) => ({ nome: f.nome, documento: f.documento || f.cnpj || null, telefone: f.telefone || null,
        email: f.email || null, endereco: f.endereco || null }));
  } catch {
    return [];
  }
}

// Leva a lista antiga para o servidor, uma vez por loja. O servidor só aceita os nomes que aparecem nas
// compras da loja aberta: a lista do navegador era a mesma para todas as lojas daquele computador.
async function importarLegado() {
  const feito = scopedKey("fornecedores_importados");
  const legado = lerLegado();
  if (!legado.length || localStorage.getItem(feito)) return;
  await axios.post(`${API}/fornecedores/importar`, { fornecedores: legado.slice(0, 500) }, cfg());
  localStorage.setItem(feito, "1");
}

export async function listarFornecedores() {
  try {
    await importarLegado();
  } catch {
    /* sem storage ou servidor fora: tenta de novo na próxima vez */
  }
  const { data } = await axios.get(`${API}/fornecedores`, cfg());
  return Array.isArray(data) ? data : [];
}

// Só os nomes, para as sugestões. Se o servidor falhar, a tela segue com os nomes das compras.
export async function nomesDosFornecedores() {
  try {
    return (await listarFornecedores()).map((f) => f.nome).filter(Boolean);
  } catch {
    return [];
  }
}

export const criarFornecedor = async (dados) => (await axios.post(`${API}/fornecedores`, dados, cfg())).data;
export const atualizarFornecedor = async (id, dados) =>
  (await axios.put(`${API}/fornecedores/${encodeURIComponent(id)}`, dados, cfg())).data;
export const excluirFornecedor = async (id) => {
  await axios.delete(`${API}/fornecedores/${encodeURIComponent(id)}`, cfg());
};

/** Detail do FastAPI (string, ou lista do 422) → texto para o toast. */
export function mensagemDoErro(e, padrao) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return padrao;
}
